export default __webpack_public_path__ + "static/media/xtreme-project-3.21ea94f6.jpg";